// extracted by mini-css-extract-plugin
export default {"divImagen":"Bienvenido_divImagen__14Ua3","divBoton":"Bienvenido_divBoton__FEuOW","img":"Bienvenido_img__VyyNy"};